import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useDebouncedAsyncSelect } from "../../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { MigaDesechoApi } from "../api/MigaDesechoApi";

// Semanas que ya tuvieron producción y siguen sin reportar su miga. La semana y
// el padre PT salen de la fila seleccionada, no se digitan
export const useSemanasPendientes = ({ tabActiva }) => {
    const {
        getPadresProductoTerminado,
        getSemanasPendientes,
        reportarMigaDesecho,
        cargando,
    } = MigaDesechoApi();

    const [semanas, setSemanas] = useState([]);
    const [cantidadResultados, setCantidadResultados] = useState(0);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [padreProductoTerminadoFiltro, setPadreProductoTerminadoFiltro] =
        useState(null);

    const [semanaSeleccionada, setSemanaSeleccionada] = useState(null);
    const [kgHumedosInput, setKgHumedosInput] = useState("");

    const loadPadresProductoTerminado = useDebouncedAsyncSelect(function (
        search,
    ) {
        return getPadresProductoTerminado({ search });
    });

    const GetSemanasPendientes = async () => {
        try {
            const params = { page: paginaSeleccionada };

            if (padreProductoTerminadoFiltro) {
                params.padre_producto_terminado_id =
                    padreProductoTerminadoFiltro.id;
            }

            const data = await getSemanasPendientes(params);

            setSemanas((data && data.results) || []);
            setCantidadResultados((data && data.count) || 0);
        } catch (error) {
            // al eliminar el último registro de una página la anterior sigue siendo válida
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al obtener las semanas pendientes de reportar",
                ),
                "Error",
                3000,
            );

            setSemanas([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        setPaginaSeleccionada(1);
    }, [padreProductoTerminadoFiltro]);

    useEffect(() => {
        if (!tabActiva) return;

        GetSemanasPendientes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginaSeleccionada, padreProductoTerminadoFiltro, tabActiva]);

    const AbrirModalReporte = (semana) => {
        setKgHumedosInput("");
        setSemanaSeleccionada(semana);
    };

    const CerrarModalReporte = () => {
        setSemanaSeleccionada(null);
        setKgHumedosInput("");
    };

    const ReportarMiga = async () => {
        if (kgHumedosInput === "" || kgHumedosInput === null) {
            NotificationManager.warning(
                "Debe ingresar los kilos húmedos de la miga. Si no hubo miga esta semana, ingrese 0",
                "Advertencia",
                3000,
            );
            return;
        }

        try {
            await reportarMigaDesecho({
                anio: semanaSeleccionada.anio,
                semana: semanaSeleccionada.semana,
                kg_humedos: parseFloat(kgHumedosInput),
                padre_producto_terminado_id:
                    semanaSeleccionada.padre_producto_terminado.id,
            });

            NotificationManager.success(
                "Miga de desecho reportada con éxito",
                "Éxito",
                3000,
            );

            CerrarModalReporte();
            await GetSemanasPendientes();
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al reportar la miga de desecho",
                ),
                "Error",
                3000,
            );
        }
    };

    return {
        semanas,
        cantidadResultados,
        paginaSeleccionada,
        setPaginaSeleccionada,
        padreProductoTerminadoFiltro,
        setPadreProductoTerminadoFiltro,
        loadPadresProductoTerminado,
        Refrescar: GetSemanasPendientes,

        semanaSeleccionada,
        AbrirModalReporte,
        CerrarModalReporte,

        kgHumedosInput,
        setKgHumedosInput,

        ReportarMiga,
        cargando,
    };
};
